import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { activity, api } from '../../lib/api';
import { useAuth } from './AuthProvider';

/** Seconds before the idle deadline at which the warning appears. */
const WARN_SECONDS = 60;

/**
 * Mirrors the reference's "Session Timeout" dialog: a countdown with "Log off" and
 * "Stay Logged In". Idle time is measured from the last successful API call, which is
 * also what the server measures.
 */
export function SessionTimeoutDialog() {
  const { idleMinutes, logout } = useAuth();
  const [remaining, setRemaining] = useState<number>(idleMinutes * 60);

  useEffect(() => {
    const tick = () =>
      setRemaining(Math.ceil((activity.last + idleMinutes * 60_000 - Date.now()) / 1000));
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [idleMinutes]);

  useEffect(() => {
    if (remaining <= 0) void logout();
  }, [remaining, logout]);

  const open = remaining > 0 && remaining <= WARN_SECONDS;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth aria-labelledby="session-timeout-title">
      <DialogTitle id="session-timeout-title">Session Timeout</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have been inactive. For your security you will be logged off in{' '}
          {Math.max(remaining, 0)} second{remaining === 1 ? '' : 's'}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => void logout()}>Log off</Button>
        <Button
          variant="contained"
          autoFocus
          onClick={() => void api.post('/auth/keepalive').catch(() => undefined)}
        >
          Stay Logged In ({Math.max(remaining, 0)})
        </Button>
      </DialogActions>
    </Dialog>
  );
}
